import uuid from 'uuid-random';
import { send } from 'server';

export const getURLs = ({ clientPlatform, casinoName, clientSkin, clientType, creferer, errorLevel }) =>
    payload => send({
        casinoName,
        clientSkinName: clientSkin,
        clientPlatform,
        clientType,
        creferer,
        errorLevel,
        ...payload,
        ID: 35844,
        correlationId: uuid(),
        responses: [31032, 31033],
        description: 'Get URLs Request'
    });
